import React, { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// @material-ui/core components
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination,
  IconButton,
  Icon,
  Tooltip,
  TextField,
  Button,
  Checkbox,
  Stepper,
  Step,
  StepLabel,
  Grid,
  StepContent,
  Typography,
  Chip,
} from "@material-ui/core";
import PropTypes from "prop-types";

// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
// core components
import { LOCALE } from "../../properties/Locale";
import {
  changePageTitle,
  notifyShowErrorMessage,
  notifyShowSuccessMessage,
} from "../../common/actions/CommonActions";
import Card from "../../common/components/Card/Card.js";
import CardHeader from "../../common/components/Card/CardHeader.js";
import CardBody from "../../common/components/Card/CardBody.js";
import { VacancyRepository } from "../vacancy/VacancyRepository";
import FormBuilderPreview from "../form-builder/FormBuilderPreview";
import BasicInfo from "./vacancyBasicInfo/BasicInfo";
import TrainingComponent from "./vacancyProfessionalDevelopment/TrainingComponent";
import ProfessionalEventComponent from "./vacancyProfessionalDevelopment/ProfessionalEventComponent";
import AuthorshipComponent from "./vacancyProfessionalDevelopment/AuthorshipComponent";
import AwardsAndRecognitionsComponent from "./vacancyProfessionalDevelopment/AwardsAndRecognitionComponent";
import EducationalActivityComponent from "./vacancyProfessionalDevelopment/EducationalActivityComponent";
import { VacancyAppRepository } from "./VacancyAppRepository";
import { withStyles } from "@material-ui/core/styles";
import StepConnector from "@material-ui/core/StepConnector";
import SettingsIcon from "@material-ui/icons/Settings";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import VideoLabelIcon from "@material-ui/icons/VideoLabel";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import FileIcon, { defaultStyles } from "react-file-icon";
import filesize from "filesize";

import clsx from "clsx";
import ProfessionalPracticeComponent from "./vacancyProfessionalPractice/ProfessionalPracticeComponent";
import { Assignment, CloudDownload } from "@material-ui/icons";
import ProfessionalTitleComponent from "./vacancyProfessionalDevelopment/ProfessionalTitleComponent";
import { SETTINGS } from "../../properties/ApiProps";
import { AuthService } from "../../auth/AuthService";

function getSteps() {
  return ["basic_info", "professional_development", "preview_and_submit"];
}

function getProfessionalDevelopmentSubsteps() {
  return [
    "Trainings",
    "Professional events",
    "Educational acitivties",
    "Awards and recognitions",
    "Authorship",
  ];
}

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <AccountBoxIcon />,
    2: <CreateNewFolderIcon />,
    3: <Assignment />,
    4: <DoneAllIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles(styles);

export default function VacancyAppPreview(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = React.useState(0);
  const [redirect, setRedirect] = React.useState(null);
  const [rerender, triggerRerender] = React.useState(false);

  const [
    activeProfessionalDevelopmentSubstep,
    setActiveProfessionalDevelopmentSubstep,
  ] = React.useState(0);
  const [vacancyId] = useState(props.match.params.vacancyId);
  const [vacancyApp, setVacancyApp] = useState();
  const [vacancy, setVacancy] = useState(null);
  const [data, setData] = useState({
    totalElements: 0,
    number: 0,
    content: [],
  });
  const steps = getSteps();
  const professionalDevelopmentSubsteps = getProfessionalDevelopmentSubsteps();
  const globalState = useSelector((state) => state);

  useEffect(() => {
    dispatch(changePageTitle("Преглед на апликација"));

    if (props.match.params.vacancyId) {
      if (!vacancy) {
        VacancyRepository.findById(props.match.params.vacancyId).then((res) => {
          setVacancy(res.data);
          triggerRerender(!rerender);
        });
      }

      if (props.match.params.vacancyApplicationId) {
        if (props.match.params.vacancyApplicationId === "new") {
          VacancyAppRepository.getAllByCurrentUserAndVacancyId(
            props.match.params.vacancyId,
          ).then((res) => {
            if (res.data.length > 0) {
              setRedirect("/app/my-vacancy-applications/");
            } else {
              VacancyAppRepository.create({
                vacancy: { id: props.match.params.vacancyId },
              }).then((res) => {
                setRedirect(
                  "/app/vacancy-application/" +
                    props.match.params.vacancyId +
                    "/" +
                    res.data.id,
                );
              });
            }
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (!vacancyApp) {
      {
        setTimeout(
          function () {
            getVacancyApp();
          }.bind(this),
          800,
        );
      }
    }
  }, [vacancyApp]);

  const getVacancyApp = () => {
    VacancyAppRepository.get(props.match.params.vacancyApplicationId).then(
      (res) => {
        console.log(res.data);
        setVacancyApp(res.data);
        if (
          res.data.status == "SUBMITTED" ||
          res.data.status == "COMMISION_EVAL" ||
          res.data.status == "REJECTED" ||
          res.data.status == "BRO_CSO_SCHOOL_EVAL" ||
          res.data.status == "SUSPENDED"
        ) {
          console.log("activeStep 2");
          setActiveStep(2);
        } else if (res.data.status == "EVALUATED") {
          console.log("activeStep 3");
          setActiveStep(3);
        }
      },
    );
  };

  const handleSubmit = () => {
    VacancyAppRepository.updateStatus(vacancyApp.id, "SUBMITTED").then(
      (res) => {
        dispatch(
          notifyShowSuccessMessage(LOCALE.application_submited_sucessfully),
        );
        setRedirect("/app/my-vacancy-applications/");
      },
      (err) => {},
    );
  };

  return (
    <div>
      {redirect && <Redirect to={redirect} />}
      <Card>
        <CardHeader style={{ textTransform: "uppercase" }} color="theme">
          <Grid container justify={"space-between"}>
            <Grid item xs={6}>
              <h3 className={classes.cardTitleWhite}>{vacancy?.name}</h3>
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            connector={<ColorlibConnector />}
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel
                  style={{ textTransform: "uppercase" }}
                  StepIconComponent={ColorlibStepIcon}
                >
                  {LOCALE.getString(label)}
                </StepLabel>
              </Step>
            ))}
          </Stepper>

          <Grid container>
            <Grid item xs={6}></Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <Typography component="span">{LOCALE.status}: </Typography>
              <Chip
                label={LOCALE.getString(vacancyApp?.status)}
                size="small"
                style={
                  vacancyApp?.status === "DRAFT"
                    ? {
                        marginTop: "-5px",
                        color: "white",
                        backgroundColor: "orange",
                      }
                    : vacancyApp?.status === "SUBMITTED"
                      ? {
                          marginTop: "-5px",
                          color: "white",
                          backgroundColor: "orange",
                        }
                      : vacancyApp?.status === "ADDITIONAL_DATA_REQUIRED"
                        ? {
                            marginTop: "-5px",
                            color: "white",
                            backgroundColor: "orange",
                          }
                        : vacancyApp?.status === "COMMISION_EVAL"
                          ? {
                              marginTop: "-5px",
                              color: "white",
                              backgroundColor: "orange",
                            }
                          : vacancyApp?.status === "BRO_CSO_SCHOOL_EVAL"
                            ? {
                                marginTop: "-5px",
                                color: "white",
                                backgroundColor: "orange",
                              }
                            : vacancyApp?.status === "EVALUATED"
                              ? {
                                  marginTop: "-5px",
                                  color: "white",
                                  backgroundColor: "green",
                                }
                              : vacancyApp?.status === "REJECTED"
                                ? {
                                    marginTop: "-5px",
                                    color: "white",
                                    backgroundColor: "red",
                                  }
                                : vacancyApp?.status === "SUSPENDED"
                                  ? {
                                      marginTop: "-5px",
                                      color: "white",
                                      backgroundColor: "red",
                                    }
                                  : {
                                      marginTop: "-5px",
                                      color: "white",
                                      backgroundColor: "white",
                                    }
                }
              />
            </Grid>
          </Grid>
          <div>
            {activeStep === 0 && (
              <div>
                <Grid container>
                  <Grid item xs={3}></Grid>
                  <Grid item xs={6}>
                    {vacancyApp && vacancyApp.id && (
                      <BasicInfo
                        vacancyAppId={vacancyApp.id}
                        handleNextStep={() => setActiveStep(activeStep + 1)}
                      />
                    )}
                  </Grid>
                  <Grid item xs={3}></Grid>
                </Grid>
              </div>
            )}
          </div>
          <div>
            {activeStep === 1 && (
              <div>
                <Stepper
                  activeStep={activeProfessionalDevelopmentSubstep}
                  orientation="vertical"
                  style={{ minHeight: "100%" }}
                >
                  <Step key={0}>
                    <StepLabel style={{ textTransform: "uppercase" }}>
                      {LOCALE.training}
                    </StepLabel>
                    <StepContent>
                      <div>
                        {vacancyApp && vacancyApp.id && (
                          <TrainingComponent
                            gradingSchemaId={
                              vacancyApp.vacancy.gradingSchema.id
                            }
                            vacancyAppId={vacancyApp.id}
                            status={vacancyApp.status}
                            handleNextStep={() =>
                              setActiveProfessionalDevelopmentSubstep(
                                activeProfessionalDevelopmentSubstep + 1,
                              )
                            }
                            handlePreviousStep={() =>
                              setActiveStep(activeStep - 1)
                            }
                          />
                        )}
                      </div>
                    </StepContent>
                  </Step>
                  <Step key={1}>
                    <StepLabel style={{ textTransform: "uppercase" }}>
                      {LOCALE.professional_event}
                    </StepLabel>
                    <StepContent>
                      <div>
                        {vacancyApp && vacancyApp.id && (
                          <ProfessionalEventComponent
                            gradingSchemaId={
                              vacancyApp.vacancy.gradingSchema.id
                            }
                            vacancyAppId={vacancyApp.id}
                            status={vacancyApp.status}
                            handleNextStep={() =>
                              setActiveProfessionalDevelopmentSubstep(
                                activeProfessionalDevelopmentSubstep + 1,
                              )
                            }
                            handlePreviousStep={() =>
                              setActiveProfessionalDevelopmentSubstep(
                                activeProfessionalDevelopmentSubstep - 1,
                              )
                            }
                          />
                        )}
                      </div>
                    </StepContent>
                  </Step>
                  <Step key={2}>
                    <StepLabel style={{ textTransform: "uppercase" }}>
                      {LOCALE.educational_activity}
                    </StepLabel>
                    <StepContent>
                      <div>
                        {vacancyApp && vacancyApp.id && (
                          <EducationalActivityComponent
                            gradingSchemaId={
                              vacancyApp.vacancy.gradingSchema.id
                            }
                            vacancyAppId={vacancyApp.id}
                            status={vacancyApp.status}
                            handleNextStep={() =>
                              setActiveProfessionalDevelopmentSubstep(
                                activeProfessionalDevelopmentSubstep + 1,
                              )
                            }
                            handlePreviousStep={() =>
                              setActiveProfessionalDevelopmentSubstep(
                                activeProfessionalDevelopmentSubstep - 1,
                              )
                            }
                          />
                        )}
                      </div>
                    </StepContent>
                  </Step>
                  <Step key={3}>
                    <StepLabel style={{ textTransform: "uppercase" }}>
                      {LOCALE.awards_and_recognition}
                    </StepLabel>
                    <StepContent>
                      <div>
                        <AwardsAndRecognitionsComponent
                          gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                          vacancyAppId={vacancyApp.id}
                          status={vacancyApp.status}
                          handleNextStep={() =>
                            setActiveProfessionalDevelopmentSubstep(
                              activeProfessionalDevelopmentSubstep + 1,
                            )
                          }
                          handlePreviousStep={() =>
                            setActiveProfessionalDevelopmentSubstep(
                              activeProfessionalDevelopmentSubstep - 1,
                            )
                          }
                        />
                      </div>
                    </StepContent>
                  </Step>
                  <Step key={4}>
                    <StepLabel style={{ textTransform: "uppercase" }}>
                      {LOCALE.professional_title}
                    </StepLabel>
                    <StepContent>
                      <div>
                        <ProfessionalTitleComponent
                          gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                          vacancyAppId={vacancyApp.id}
                          status={vacancyApp.status}
                          handleNextStep={() =>
                            setActiveProfessionalDevelopmentSubstep(
                              activeProfessionalDevelopmentSubstep + 1,
                            )
                          }
                          handlePreviousStep={() =>
                            setActiveProfessionalDevelopmentSubstep(
                              activeProfessionalDevelopmentSubstep - 1,
                            )
                          }
                        />
                      </div>
                    </StepContent>
                  </Step>
                  <Step key={5}>
                    <StepLabel style={{ textTransform: "uppercase" }}>
                      {LOCALE.authorship}
                    </StepLabel>
                    <StepContent>
                      <div>
                        <AuthorshipComponent
                          gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                          vacancyAppId={vacancyApp.id}
                          status={vacancyApp.status}
                          handleNextStep={() => setActiveStep(activeStep + 1)}
                          handlePreviousStep={() =>
                            setActiveProfessionalDevelopmentSubstep(
                              activeProfessionalDevelopmentSubstep - 1,
                            )
                          }
                        />
                      </div>
                    </StepContent>
                  </Step>
                </Stepper>
              </div>
            )}
          </div>
          <div>
            {activeStep === 2 && (
              <div>
                {vacancyApp && vacancyApp.id && (
                  <div>
                    <BasicInfo vacancyAppId={vacancyApp.id} disabled={true} />
                    <hr></hr>
                    <br></br>
                    <br></br>

                    <TrainingComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>

                    <ProfessionalEventComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <EducationalActivityComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <AwardsAndRecognitionsComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <ProfessionalTitleComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <AuthorshipComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                    />
                    {vacancyApp?.status === "DRAFT" && (
                      <div>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ float: "right" }}
                          onClick={() => handleSubmit()}
                        >
                          {LOCALE.submit_app}
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          style={{ float: "left" }}
                          onClick={() => setActiveStep(activeStep - 1)}
                        >
                          {LOCALE.previous}
                        </Button>
                      </div>
                    )}
                    {vacancyApp?.status === "ADDITIONAL_DATA_REQUIRED" && (
                      <div>
                        <Button
                          variant="contained"
                          color="secondary"
                          style={{ float: "right" }}
                          onClick={() => handleSubmit()}
                        >
                          {LOCALE.submit_app}
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          style={{ float: "left" }}
                          onClick={() => setActiveStep(activeStep - 1)}
                        >
                          {LOCALE.previous}
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div>
            {activeStep === 3 && (
              <div>
                {vacancyApp && vacancyApp.id && (
                  <div>
                    <BasicInfo vacancyAppId={vacancyApp.id} disabled={true} />
                    <hr></hr>
                    <br></br>
                    <br></br>

                    <TrainingComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                      showPoints={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>

                    <ProfessionalEventComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                      showPoints={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <EducationalActivityComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                      showPoints={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <AwardsAndRecognitionsComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                      showPoints={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <ProfessionalTitleComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                      showPoints={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <AuthorshipComponent
                      gradingSchemaId={vacancyApp.vacancy.gradingSchema.id}
                      vacancyAppId={vacancyApp.id}
                      disabled={true}
                      showPoints={true}
                    />
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <React.Fragment>
                      <Card>
                        <CardHeader
                          color="theme"
                          style={{ padding: "8px", paddingLeft: "15px" }}
                        >
                          <Typography>Оценување од БРО</Typography>
                        </CardHeader>
                        <CardBody>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell>
                                  <strong>{LOCALE.fileName}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.fileSize}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.actions}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.points}</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(vacancyApp.bureauGrading &&
                                vacancyApp.bureauGrading.attachments &&
                                vacancyApp.bureauGrading.attachments.length >
                                  0) === false && (
                                <TableRow>
                                  <TableCell colSpan={4}>
                                    <Icon
                                      style={{
                                        verticalAlign: "bottom",
                                        color: "orange",
                                      }}
                                    >
                                      warning
                                    </Icon>{" "}
                                    {LOCALE.no_documents_attached}
                                  </TableCell>
                                </TableRow>
                              )}
                              {vacancyApp.bureauGrading &&
                                vacancyApp.bureauGrading.attachments &&
                                vacancyApp.bureauGrading?.attachments.map(
                                  (attachment, index) => (
                                    <TableRow>
                                      <TableCell>
                                        <FileIcon
                                          size={50}
                                          extension={attachment.fileExtension}
                                          {...defaultStyles[
                                            attachment.fileExtension
                                          ]}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        {attachment.filename}
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        {filesize(attachment.fileSize)}
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        <a
                                          target="blank"
                                          href={`${
                                            SETTINGS.API_URL
                                          }vacancyApplications/${
                                            vacancyApp.id
                                          }/attachments/${
                                            attachment.id
                                          }?access_token=${
                                            AuthService.getToken().access_token
                                          }`}
                                        >
                                          <IconButton
                                            size="small"
                                            color="secondary"
                                            aria-label="Download"
                                          >
                                            <Icon>cloud_download</Icon>
                                          </IconButton>
                                        </a>
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        {vacancyApp?.bureauGrading?.points}
                                      </TableCell>
                                    </TableRow>
                                  ),
                                )}
                            </TableBody>
                          </Table>
                        </CardBody>
                      </Card>
                    </React.Fragment>
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <React.Fragment>
                      <Card>
                        <CardHeader
                          color="theme"
                          style={{ padding: "8px", paddingLeft: "15px" }}
                        >
                          <Typography>Оценување од ЦСОО</Typography>
                        </CardHeader>
                        <CardBody>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell>
                                  <strong>{LOCALE.fileName}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.fileSize}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.actions}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.points}</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {vacancyApp.educationalCenterGrading == null && (
                                <TableRow>
                                  <TableCell colSpan={4}>
                                    <Icon
                                      style={{
                                        verticalAlign: "bottom",
                                        color: "orange",
                                      }}
                                    >
                                      warning
                                    </Icon>{" "}
                                    {LOCALE.no_documents_attached}
                                  </TableCell>
                                </TableRow>
                              )}
                              {vacancyApp.educationalCenterGrading &&
                                vacancyApp.educationalCenterGrading
                                  .attachments &&
                                vacancyApp.educationalCenterGrading?.attachments.map(
                                  (attachment, index) => (
                                    <TableRow>
                                      <TableCell>
                                        <FileIcon
                                          size={50}
                                          extension={attachment.fileExtension}
                                          {...defaultStyles[
                                            attachment.fileExtension
                                          ]}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        {attachment.filename}
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        {filesize(attachment.fileSize)}
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        <a
                                          target="blank"
                                          href={`${
                                            SETTINGS.API_URL
                                          }vacancyApplications/${
                                            vacancyApp.id
                                          }/attachments/${
                                            attachment.id
                                          }?access_token=${
                                            AuthService.getToken().access_token
                                          }`}
                                        >
                                          <IconButton
                                            size="small"
                                            color="secondary"
                                            aria-label="Download"
                                          >
                                            <Icon>cloud_download</Icon>
                                          </IconButton>
                                        </a>
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        {
                                          vacancyApp?.educationalCenterGrading
                                            ?.points
                                        }
                                      </TableCell>
                                    </TableRow>
                                  ),
                                )}
                            </TableBody>
                          </Table>
                        </CardBody>
                      </Card>
                    </React.Fragment>
                    <hr></hr>
                    <br></br>
                    <br></br>
                    <React.Fragment>
                      <Card>
                        <CardHeader
                          color="theme"
                          style={{ padding: "8px", paddingLeft: "15px" }}
                        >
                          <Typography>Оценување од Училиште</Typography>
                        </CardHeader>
                        <CardBody>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell></TableCell>
                                <TableCell>
                                  <strong>{LOCALE.fileName}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.fileSize}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.actions}</strong>
                                </TableCell>
                                <TableCell
                                  style={{
                                    width: "200px",
                                    textAlign: "center",
                                  }}
                                >
                                  <strong>{LOCALE.points}</strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(vacancyApp.schoolGrading &&
                                vacancyApp.schoolGrading.attachments &&
                                vacancyApp.schoolGrading.attachments.length >
                                  0) === false && (
                                <TableRow>
                                  <TableCell colSpan={4}>
                                    <Icon
                                      style={{
                                        verticalAlign: "bottom",
                                        color: "orange",
                                      }}
                                    >
                                      warning
                                    </Icon>{" "}
                                    {LOCALE.no_documents_attached}
                                  </TableCell>
                                </TableRow>
                              )}
                              {vacancyApp.schoolGrading &&
                                vacancyApp.schoolGrading.attachments &&
                                vacancyApp.schoolGrading?.attachments.map(
                                  (attachment, index) => (
                                    <TableRow>
                                      <TableCell>
                                        <FileIcon
                                          size={50}
                                          extension={attachment.fileExtension}
                                          {...defaultStyles[
                                            attachment.fileExtension
                                          ]}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        {attachment.filename}
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        {filesize(attachment.fileSize)}
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        <a
                                          target="blank"
                                          href={`${
                                            SETTINGS.API_URL
                                          }vacancyApplications/${
                                            vacancyApp.id
                                          }/attachments/${
                                            attachment.id
                                          }?access_token=${
                                            AuthService.getToken().access_token
                                          }`}
                                        >
                                          <IconButton
                                            size="small"
                                            color="secondary"
                                            aria-label="Download"
                                          >
                                            <Icon>cloud_download</Icon>
                                          </IconButton>
                                        </a>
                                      </TableCell>
                                      <TableCell
                                        style={{ textAlign: "center" }}
                                      >
                                        {vacancyApp?.schoolGrading?.points}
                                      </TableCell>
                                    </TableRow>
                                  ),
                                )}
                            </TableBody>
                          </Table>
                        </CardBody>
                      </Card>
                    </React.Fragment>
                  </div>
                )}
              </div>
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
